import React from "react";
import { OrderTypes } from "../../../types/OrderTypes";

function OrderActionsSection({
  typeId,
  showDelete,
  onStatusOpen,
  onDelete,
  statusDisabled,
}) {
  const type = Number(typeId);
  const isSales = type === OrderTypes.SALES;
  const isReplenishmentOrExpense =
    type === OrderTypes.REPLENISH ||
    type === OrderTypes.EXPENSES ||
    type === OrderTypes.INVESTMENT;
  const canDelete = Boolean(showDelete) || isReplenishmentOrExpense;
  const canChangeStatus = isSales;

  if (!canDelete && !canChangeStatus) {
    return null;
  }

  return (
    <footer className="order-detail-footerRow">
      <div className="order-detail-actions">
        {canDelete ? (
          <button
            type="button"
            className="order-detail-actionBtn order-detail-actionBtn--danger"
            onClick={onDelete}
          >
            Удалить
          </button>
        ) : null}
        {canChangeStatus ? (
          <button
            type="button"
            className="order-detail-actionBtn order-detail-actionBtn--primary"
            onClick={onStatusOpen}
            disabled={statusDisabled}
          >
            Статус
          </button>
        ) : null}
      </div>
    </footer>
  );
}

export default OrderActionsSection;
